import type { Color } from "../../../shared/types/common-types";

const levenshteinDistance = (a: string, b: string): number => {
	const m = a.length;
	const n = b.length;
	const d: number[][] = [];

	for (let i = 0; i <= m; i++) {
		d[i] = [i];
	}

	for (let j = 1; j <= n; j++) {
		d[0][j] = j;
	}

	for (let j = 1; j <= n; j++) {
		for (let i = 1; i <= m; i++) {
			if (a[i - 1] === b[j - 1]) {
				d[i][j] = d[i - 1][j - 1];
			} else {
				d[i][j] = Math.min(
					d[i - 1][j] + 1, // deletion
					d[i][j - 1] + 1, // insertion
					d[i - 1][j - 1] + 1, // substitution
				);
			}
		}
	}

	return d[m][n];
};

export const stringMatchingPrecision = (a: string, b: string): number => {
	const distance = levenshteinDistance(a, b);
	const maxLength = Math.max(a.length, b.length);
	return 1 - distance / maxLength;
};

export const getScoreMessage = (
	score: number,
): {
	message: string;
	color: Color;
} => {
	switch (true) {
		case score > 0.9:
			return {
				message: "Excellent",
				color: "green",
			};
		case score > 0.6:
			return {
				message: "Good, but you can do better",
				color: "yellow",
			};
		case score > 0.4:
			return {
				message: "Fair, but you can do better",
				color: "orange",
			};
		default:
			return {
				message: "Not so good, try again",
				color: "red",
			};
	}
};

export const getLocaleByLanguage = (language: string): string => {
	switch (language) {
		case "english":
			return "en-US";
		case "russian":
			return "ru-RU";
		default:
			return "en-US";
	}
};
